import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaLock, FaUser } from 'react-icons/fa';

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  
  const ADMIN_PASSWORD = process.env.COMPARIT_ADMIN_PASSWORD;

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (password === ADMIN_PASSWORD) {
      // Set authentication in localStorage
      localStorage.setItem('adminAuthenticated', 'true');
      // Redirect to admin page
      navigate('/admin');
    } else {
      setError('Invalid password. Please try again.');
      setPassword('');
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="admin-login-header">
          <FaLock className="lock-icon" />
          <h2>Admin Access</h2>
        </div>
        
        {error && <div className="admin-login-error">{error}</div>}
        
        <form onSubmit={handleSubmit} className="admin-login-form">
          <div className="admin-input-group">
            <label htmlFor="password">
              <FaUser className="input-icon" />
              Password
            </label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              required
            />
          </div>
          
          <button type="submit" className="admin-login-button">
            Access Admin Panel
          </button>
        </form>
        
        <div className="admin-login-footer">
          <p>This area is restricted to administrators only.</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin; 